<template lang="pug">
div
  input.form-control(type="text", v-model="model" list="macrosOptions")
  datalist#macrosOptions
    option(v-for="item in macros.filter(m => m.hidden !== true)", :key="item.param", :value="item.param")
  .url-validator.mb-1(v-if="macroValidator.visible")
          p.clearfix
          .message
            i.la.mr-1(:class="{'la-check': macroValidator.valid, 'la-warning': !macroValidator.valid}")
            span(style="font-weight: 600") {{ macroValidator.message }} !
                     
</template>
<script>
import Vue from 'vue';

  export default {
    name: 'MacroInput',
    props: {
      value: String,
      macros: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        macroValidator: {
          highlight: '',
          style: '',
          valid: true,
          visible: false,
        },
      };
    },
    computed: {
      model: {
        get() {
          return this.value;
        },
        set(v) {
          let val = (v || '').trim();
          const selectedOption = this.macros.find(item => item.param === val);
          if (selectedOption) {
            val = `{${val}}`;
          }

          this.validate(val);
          this.$emit('input', val);
        },
      },
    },
    methods: {

      showHelper(valid, highlight, message) {
        const invalidColor = 'rgba(220,53,69,0.6)';
        const validColor = '#40dc7e6b';
        if (!this.macroValidator.valid || !valid) {
          /** show if was invalid or currently invalid */
          Vue.set(this.macroValidator, 'visible', !valid /*true*/); // // Show message only on error; change !valid to true to show on success too
          if (valid) {
            setTimeout(() => {
              Vue.set(this.macroValidator, 'visible', false);
            }, 2000);
          }
        }
        Vue.set(this.macroValidator, 'style', {
          'background-color': valid ? validColor : invalidColor,
        });
        Vue.set(this.macroValidator, 'valid', valid);
        Vue.set(this.macroValidator, 'highlight', highlight);
        Vue.set(this.macroValidator, 'message', message || '');
      },

      validate: function (fieldValue) {
        fieldValue = fieldValue.trim();

        if (fieldValue) {

          /** check for unclosed parentheses */
          let counter = 0,
            validParentheses = true;
          for (let i = 0; i < fieldValue.length; i++) {
            if (fieldValue[i] === '{') {
              counter++;
            } else if (fieldValue[i] === '}') {
              counter--;
            }
            if (counter < 0) {
              validParentheses = false;
            }
          }
          if (!validParentheses || counter !== 0) {
            return this.showHelper(false, /[{,}]/, 'Unclosed parentheses');
          }

          /** check allowed characters: a-z, A-Z, 0-9, -, _ inside curly braces */
          if (!this.isValidRegex(fieldValue)) {
            return this.showHelper(false, '', 'Invalid characters');
          }

          /** check input macros are matching the supplied macros */
          const arrayOfMacros = fieldValue.match(/{[^}{]*}/g);
          let invalidMacros = [];
          if (arrayOfMacros && arrayOfMacros.length) {
            for (let macro of arrayOfMacros) {
              let macroKey = macro.substr(1, macro.length - 2);
              let matchingMacro = this.macros.find(
                (m) => m.param === macroKey || (m.aliases && m.aliases.includes(macroKey)),
              );
              if (!matchingMacro) {
                invalidMacros.push(macroKey);
              }
            }
          }
          if (invalidMacros.length) {
            return this.showHelper(
              false,
              invalidMacros.map((m) => `{${m}}`),
              'Invalid macro',
            );
          }

          this.showHelper(true, /{[^}{]*}/g, 'Link is valid');
        } else {
          Vue.set(this.macroValidator, 'visible', false);
          Vue.set(this.macroValidator, 'valid', true);
          Vue.set(this.macroValidator, 'message', '');
        }
      },

      isValidRegex(value) {
        const regex = /^(([a-zA-Z0-9_-]+)|(\{[a-zA-Z0-9_.-]+\}))*$/;
        return regex.test(value);
      },
    },
  };
  
</script>
